import { cloneDeep } from 'lodash';

import { enableShareLink } from '@/api/orders';
import bus from '@/utils/bus';
import { SNACKBAR_TYPES } from '@/utils/constants';

export default {
  name: 'CustomLinkModal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    order: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isDisablingLink: false,
    };
  },
  methods: {
    onClose() {
      this.$emit('input', false);
      this.$emit('close');
    },
    async onDisableShareLink() {
      this.isDisablingLink = true;
      try {
        await enableShareLink({
          enable: false,
          orderId: this.order.id,
        });
        const copy = cloneDeep(this.order);
        copy.share.share_status = false;
        bus.$emit('SET_ORDER', copy);
        this.onClose();
      } catch (error) {
        const { message: msg = '' } = error;
        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          title: '開啟訪客訂購連結失敗，請重試一次',
          msg,
        });
      } finally {
        this.isDisablingLink = false;
      }
    },
  },
};
